import Subscribe from './index.vue';

export default Subscribe;